import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { expireSubScription, logoutUser } from "../../redux/action/userActions";
import { CONTACTUSURL, SMALLLOGO } from "../../redux/types/index";
const ExpiredSubscription = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = () => {
    dispatch(expireSubScription());
    dispatch(logoutUser());

    navigate("/login");
  };

  const handleContact = () => {
    window.open(CONTACTUSURL);
  };

  return (
    <div className="account-body accountbg">
      <div className="container">
        <div className="row vh-100 ">
          <div className="col-12 align-self-center">
            <div className="auth-page">
              <div className="card auth-card shadow-lg">
                <div className="card-body">
                  <div className="px-3">
                    <div className="auth-logo-box">
                      <a
                        href="/analytics/analytics-index"
                        className="logo logo-admin"
                      >
                        <img
                          src={SMALLLOGO}
                          height="55"
                          alt="logo"
                          className="auth-logo"
                        />
                      </a>
                    </div>
                    <img
                      src="/images/expiredsubscription.png"
                      alt=""
                      className="d-block mx-auto mt-4"
                      height="250"
                    />
                    <div className="text-center auth-logo-text mb-4">
                      <h6>Oh snap!</h6>

                      <h4 className="mt-0 mb-3 mt-2">
                        Looks like your subscription has been expired.
                      </h4>

                      <button
                        onClick={() => {
                          handleLogin();
                        }}
                        className="btn btn-sm btn-outline-primary"
                      >
                        Back to Login
                      </button>
                    </div>
                    <div className="text-center auth-logo-text mb-4">
                      <button
                        onClick={() => {
                          handleContact();
                        }}
                        className="btn btn-lg btn-gradient-primary "
                      >
                        Contact Mealbill
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpiredSubscription;
